export const types = <const>{
	mutations: {
		ND_CENIK_RABAT_SK_SELECT_MAPPER: 'ND_CENIK_RABAT_SK_SELECT_MAPPER',
		ND_CENIK_ZBOZI_DRUH_SELECT_MAPPER: 'ND_CENIK_ZBOZI_DRUH_SELECT_MAPPER',
	},
};
